<div class="h-100 row align-items-center">
  <div class="col">
    <div class="error-text">
      <p *ngIf="isLoginLinkExpiry">
        This link has expired. Please
        <a [routerLink]="['/login']">click here</a> to return to the login page.
      </p>
      <p *ngIf="!isLoginLinkExpiry">
        An unexpected has occured. Please
        <a [routerLink]="['/login']">click here</a> to log back in again.
      </p>
    </div>
  </div>
</div>
